if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cart-recommendations__list');
        this.controls = this.querySelector('.cart-recommendations__controls');
        this.previousButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.list || !this.controls || !this.previousButton || !this.nextButton) return;

        this.onScroll = this.updateButtons.bind(this);
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton.addEventListener('click', () => this.scrollByPage(-1));
        this.nextButton.addEventListener('click', () => this.scrollByPage(1));

        // The list's scrollable width is not settled when this runs: on first
        // load the stylesheet may not have applied yet, and on a drawer re-render
        // images and fonts are still arriving. Re-measure whenever it changes
        // rather than trusting a single reading at connect time.
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.list);
          this.list.querySelectorAll('.cart-recommendations__item').forEach((item) => this.resizeObserver.observe(item));
        } else {
          this.onResize = this.updateButtons.bind(this);
          window.addEventListener('resize', this.onResize);
        }

        this.updateButtons();
        requestAnimationFrame(() => this.updateButtons());
      }

      disconnectedCallback() {
        if (this.list && this.onScroll) this.list.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      get slideWidth() {
        const item = this.querySelector('.cart-recommendations__item');
        if (!item) return this.list.clientWidth;
        const gap = parseFloat(getComputedStyle(this.list).columnGap || 0) || 0;
        return item.offsetWidth + gap;
      }

      scrollByPage(direction) {
        const slide = this.slideWidth;
        if (!slide) return;
        const perPage = Math.max(1, Math.floor(this.list.clientWidth / slide));
        this.list.scrollBy({ left: slide * perPage * direction, behavior: 'smooth' });
      }

      updateButtons() {
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        const isScrollable = maxScroll > 1;

        this.controls.hidden = !isScrollable;
        this.previousButton.disabled = !isScrollable || this.list.scrollLeft <= 1;
        this.nextButton.disabled = !isScrollable || this.list.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
